import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nfkjydendnxpmdzixivq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ma2p5ZGVuZG54cG1keml4aXZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMTMwMDQsImV4cCI6MjA2ODU4OTAwNH0.2uQpqXw7znUY_8OyXMUbt-nyo-ijpiIBRZGEYfG7Qj0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
